// extracted by mini-css-extract-plugin
export default {"organization":"styles_organization__6xV8M","input":"styles_input__9m6XV","locations":"styles_locations__XS3Fy"};